
import { useCallback, useEffect, useState } from "react";
import { useArticlesLoader } from "./articles/useArticlesLoader";
import { useArticleActions } from "./articles/useArticleActions";

export const useAdminArticles = () => {
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  
  const { 
    articles, 
    tags, 
    authors, 
    loading, 
    loadArticles, 
    loadTags, 
    loadAuthors,
    articlesLoading,
    tagsLoading,
    authorsLoading
  } = useArticlesLoader();

  const {
    createArticle,
    updateArticle,
    deleteArticle,
    createTag,
    uploadMediaToStorage,
    fetchMedia,
    updateMediaMetadata,
    deleteMedia,
    createAuthor,
    updateAuthor,
    deleteAuthor,
    fetchArticleById
  } = useArticleActions();
  
  // Load all required data only once on initial mount
  useEffect(() => {
    if (!initialLoadComplete) {
      // Avoid duplicate loading by using Promise.all for parallel loading
      const loadInitialData = async () => {
        await Promise.all([
          loadAuthors(),
          loadTags(),
          loadArticles()
        ]);
        setInitialLoadComplete(true);
      };
      
      loadInitialData();
    }
  }, [loadAuthors, loadTags, loadArticles, initialLoadComplete]);

  return {
    articles,
    tags,
    authors,
    loading,
    loadArticles,
    loadTags,
    loadAuthors,
    createArticle,
    updateArticle,
    deleteArticle,
    createTag,
    uploadMediaToStorage,
    fetchMedia,
    updateMediaMetadata, 
    deleteMedia,
    createAuthor,
    updateAuthor,
    deleteAuthor,
    fetchArticleById
  };
};
